import { Route } from "react-router-dom";
import { lazyWithRetry as lazy } from "@/lib/lazyWithRetry";
import ProtectedRoute from "@/components/ProtectedRoute";
import FeatureRoute from "@/components/FeatureRoute";

const UtilisateursPage = lazy(() => import("@/pages/config/UtilisateursPage"));
const ParametresPage = lazy(() => import("@/pages/config/ParametresPage"));
const DonneesReferencePage = lazy(() => import("@/pages/config/DonneesReferencePage"));
const DonneesReferencePOSPage = lazy(() => import("@/pages/config/DonneesReferencePOSPage"));
const ConversionsPage = lazy(() => import("@/pages/config/ConversionsPage"));
const IdentiteSocietePage = lazy(() => import("@/pages/config/IdentiteSocietePage"));
const AuditRLSPage = lazy(() => import("@/pages/config/AuditRLSPage"));
const EmailsMonitoringPage = lazy(() => import("@/pages/config/EmailsMonitoringPage"));
const FeatureFlagsPage = lazy(() => import("@/pages/config/FeatureFlagsPage"));
const MaintenancePage = lazy(() => import("@/pages/config/MaintenancePage"));
const CaisseHardwarePage = lazy(() => import("@/pages/config/CaisseHardwarePage"));
const AlertesConfigPage = lazy(() => import("@/pages/config/AlertesConfigPage"));
const PlanSalleConfigRedirect = lazy(() => import("@/pages/config/PlanSalleConfigRedirect"));
const QaScenariosPage = lazy(() => import("@/pages/qa/QaScenariosPage"));
const PlanSallePage = lazy(() => import("@/pages/pos/PlanSallePage"));
const ReservationsPage = lazy(() => import("@/pages/pos/ReservationsPage"));
const TablesConfigPage = lazy(() => import("@/pages/pos/config/TablesConfigPage"));
const KdsConfigPage = lazy(() => import("@/pages/pos/kds/KdsConfigPage"));
const KdsManagerPage = lazy(() => import("@/pages/pos/kds/KdsManagerPage"));

export function configRoutes() {
  return (
    <>
      <Route
        path="/config/utilisateurs"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <UtilisateursPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/emails"
        element={
          <ProtectedRoute allowedRoles={["admin", "pdg"]}>
            <EmailsMonitoringPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/identite-societe"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <IdentiteSocietePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/parametres"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "gerante", "admin"]}>
            <ParametresPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/donnees-reference"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "admin"]}>
            <DonneesReferencePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/donnees-reference-pos"
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin"]}>
            <FeatureRoute flag="config.phase2"><DonneesReferencePOSPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/conversions"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "gerante", "admin"]}>
            <ConversionsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/audit-rls"
        element={
          <ProtectedRoute allowedRoles={["admin", "pdg", "gerante"]}>
            <AuditRLSPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/feature-flags"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <FeatureFlagsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/maintenance"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <MaintenancePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/caisse"
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin"]}>
            <FeatureRoute flag="config.phase2"><CaisseHardwarePage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/alertes"
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin"]}>
            <FeatureRoute flag="config.phase2"><AlertesConfigPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/plan-salle"
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin"]}>
            <FeatureRoute flag="config.phase2"><PlanSalleConfigRedirect /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/config/kds"
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin"]}>
            <FeatureRoute flag="pos.kds"><KdsConfigPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/qa"
        element={
          <ProtectedRoute allowedRoles={["admin", "pdg", "gerante"]}>
            <QaScenariosPage />
          </ProtectedRoute>
        }
      />

      {/* POS config (plan salle, réservations, tables) */}
      <Route
        path="/pos/plan-salle"
        element={
          <ProtectedRoute>
            <FeatureRoute flag="pos.plan_salle"><PlanSallePage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/pos/reservations"
        element={
          <ProtectedRoute>
            <FeatureRoute flag="pos.plan_salle"><ReservationsPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/pos/config/tables"
        element={
          <ProtectedRoute allowedRoles={["gerante", "admin"]}>
            <FeatureRoute flag="pos.plan_salle"><TablesConfigPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/manager/kds"
        element={
          <ProtectedRoute allowedRoles={["chef_salle", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="pos.kds"><KdsManagerPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
    </>
  );
}
